export default __webpack_public_path__ + "static/media/card.4ec8eaaa.svg";